module.exports = __webpack_public_path__ + "static/media/14.e3b1e6e0.jpg";